/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import actions from '../action/notificationAction'

export const initialState = ({
  notificationList: [],
})


export default function (state = initialState, action) {
  switch (action.type) {

    case actions.TYPES.REQUEST_NOTIFICATION:
      return Object.assign({}, state, { notificationList: action.payload})

    case actions.TYPES.REQUEST_NOTIFICATION_SUCCESS:
      return Object.assign({}, state, { notificationList: action.payload})

    case actions.TYPES.UPDATE_NOTIFICATION_LIST:
      return Object.assign({}, state, { notificationList: action.payload})

    default:
      return state
  }
}
